import { Modal } from "../Modal/Modal";

type ConfirmActionModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
  title: string;
  message?: string;
  confirmText?: string;
  cancelText?: string;
  cypressModalHeaderSelector?: string;
};

export const ConfirmActionModal = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading = false,
  title,
  message,
  confirmText = "Delete",
  cancelText = "Cancel",
  cypressModalHeaderSelector,
}: ConfirmActionModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      onPrimaryButtonClicked={onConfirm}
      modalTitle={title}
      modalText={message}
      primaryLoading={isLoading}
      disablePrimaryButton={isLoading}
      primaryButtonText={confirmText}
      secondaryButtonText={cancelText}
      cypressModalHeaderSelector={cypressModalHeaderSelector}
      size="md"
      isCentered
    />
  );
};

